import type { SVGProps } from 'react'

export const IconWarning = (props: SVGProps<SVGSVGElement>) => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<g clipPath='url(#clip0_7317_4149)'>
			<path
				d='M12.0479 14.0096C12.6055 14.0096 13 13.5584 13 13.0008V7.00004C13 6.44241 12.5488 5.99121 12.0479 5.99121C11.5469 5.99121 11.0391 6.44518 11.0391 7.00004V13.0008C11.0391 13.5557 11.493 14.0096 12.0479 14.0096Z'
				fill='currentColor'
			/>
			<path
				d='M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z'
				fill='currentColor'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.2739 2.28328L18.9561 10.2023L23.6384 18.1213C24.1117 18.9181 24.1211 19.8742 23.6623 20.6771C23.1908 21.5038 22.3359 21.9974 21.3746 21.9974H2.63161C1.66845 21.9974 0.812618 21.5052 0.338687 20.6785C-0.119609 19.8742 -0.112579 18.9195 0.358456 18.1241L9.7276 2.28234C10.2057 1.479 11.054 1 12.0007 1C12.9475 1.00141 13.8005 1.48135 14.2739 2.28328ZM20.8877 20.069C21.3207 20.069 21.6733 19.8681 21.8251 19.4932C22.0483 19.212 22.0037 18.8504 21.8546 18.5353L12.9316 3.44796C12.7397 3.12296 12.3917 2.92908 12.0005 2.92838C11.6077 2.92838 11.2595 3.123 11.0676 3.44885L2.14359 18.5353C1.9574 18.8504 1.95459 19.2139 2.13662 19.5333C2.32856 19.8688 2.68003 20.069 3.07757 20.069H20.8877Z'
				fill='currentColor'
			/>
		</g>
		<defs>
			<clipPath id='clip0_7317_4149'>
				<rect width='24' height='24' fill='currentColor' />
			</clipPath>
		</defs>
	</svg>
)
